import * as React from 'react';

const LightbulbChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        id="lightbulb-chunky_svg__eds-icon-lightbulb-chunky"
        viewBox="0 0 14 21"
        {...props}
    >
        <path
            className="lightbulb-chunky_svg__eds-icon-lightbulb-chunky"
            clipRule="evenodd"
            strokeWidth={1}
            d="M7 1a6 6 0 012 11.658V16H5v-3.341A6 6 0 017 1zM4 20h6"
            id="lightbulb-chunky_svg__Oval-2"
            stroke="#39364F"
        />
    </svg>
);

LightbulbChunkySvg.displayName = 'LightbulbChunkySvg';
export default LightbulbChunkySvg;
